var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "userInfo",
        },
        [
          _c("div", { staticClass: "infoLeft" }, [
            _c(
              "div",
              { staticClass: "leftTop" },
              [
                _vm.userInfo.HeadImg
                  ? _c("el-avatar", {
                      attrs: { size: 60, src: _vm.userInfo.HeadImg },
                    })
                  : _c("el-avatar", {
                      attrs: { size: 60, icon: "el-icon-user-solid" },
                    }),
                _c("span", { staticClass: "userName" }, [
                  _vm._v(_vm._s(_vm.userInfo.RealName)),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "leftBottom" }, [
              _c(
                "ul",
                _vm._l(_vm.menuList, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.title,
                      class: _vm.menuActive == item.title ? "active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.menuClick(item)
                        },
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(item.title) + " "),
                      item.title == "通知" && _vm.UnreadTotal > 0
                        ? _c("el-badge", {
                            staticClass: "item",
                            attrs: { value: _vm.UnreadTotal, max: 99 },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "infoRight" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.menuActive == "用户信息",
                    expression: "menuActive == '用户信息'",
                  },
                ],
                staticClass: "rightCard",
              },
              [
                _c("div", { staticClass: "cardHeader" }, [
                  _vm._v(_vm._s(_vm.menuActive)),
                ]),
                _c(
                  "div",
                  { staticClass: "cardContent" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "formUser",
                        attrs: {
                          model: _vm.userInfo,
                          "label-width": "100px",
                          "label-position": "left",
                          rules: _vm.rules,
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "头像" } },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  action:
                                    _vm.$rootUrl +
                                    `/Base_Manage/Upload/UploadFileByForm`,
                                  headers: {
                                    Authorization: _vm.token,
                                  },
                                  "show-file-list": false,
                                  "on-success": _vm.handleAvatarSuccess,
                                  "before-upload": _vm.beforeAvatarUpload,
                                },
                              },
                              [
                                _vm.userInfo.HeadImg
                                  ? _c("el-image", {
                                      staticClass: "HeadImg",
                                      attrs: {
                                        fit: "contain",
                                        src: _vm.userInfo.HeadImg,
                                      },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon",
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "用户编号", prop: "UserCode" } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.userInfo.UserCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userInfo, "UserCode", $$v)
                                },
                                expression: "userInfo.UserCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "用户名账号", prop: "UserName" } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.userInfo.UserName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userInfo, "UserName", $$v)
                                },
                                expression: "userInfo.UserName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "姓名", prop: "RealName" } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.userInfo.RealName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userInfo, "RealName", $$v)
                                },
                                expression: "userInfo.RealName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "性别", prop: "Sex" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.userInfo.Sex,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "Sex", $$v)
                                  },
                                  expression: "userInfo.Sex",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("女"),
                                ]),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("男"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "手机号", prop: "Telephone" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入手机号" },
                              model: {
                                value: _vm.userInfo.Telephone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userInfo, "Telephone", $$v)
                                },
                                expression: "userInfo.Telephone",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  loading: _vm.loading,
                                },
                                on: { click: _vm.onSubmitUserInfo },
                              },
                              [_vm._v("保存 ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.menuActive == "修改密码",
                    expression: "menuActive == '修改密码'",
                  },
                ],
              },
              [
                _c("div", { staticClass: "rightCard" }),
                _c("div", { staticClass: "rightCard" }, [
                  _c("div", { staticClass: "cardHeader" }, [
                    _vm._v("修改密码"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "cardContent" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: {
                            model: _vm.form,
                            "label-width": "100px",
                            "label-position": "right",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "旧密码：" } },
                            [
                              _c("el-input", {
                                attrs: { "show-password": "" },
                                model: {
                                  value: _vm.form.oldPwd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "oldPwd", $$v)
                                  },
                                  expression: "form.oldPwd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "新密码：" } },
                            [
                              _c("el-input", {
                                attrs: { "show-password": "" },
                                model: {
                                  value: _vm.form.newPwd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "newPwd", $$v)
                                  },
                                  expression: "form.newPwd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "确认新密码：" } },
                            [
                              _c("el-input", {
                                attrs: { "show-password": "" },
                                model: {
                                  value: _vm.form.confirmPwd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "confirmPwd", $$v)
                                  },
                                  expression: "form.confirmPwd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "lastBtn" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    loading: _vm.loading,
                                    size: "mini",
                                    type: "primary",
                                  },
                                  on: { click: _vm.onSubmit },
                                },
                                [_vm._v("保存 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置签名",
            visible: _vm.signQrcodeDialogVisible,
            width: "300px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.signQrcodeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                color: "red",
                "font-weight": "bold",
                "font-size": "16px",
                "text-align": "center",
              },
            },
            [_vm._v(" 请用手机扫描二维码设置签名 ")]
          ),
          _c(
            "div",
            { staticStyle: { width: "100%", "text-align": "center" } },
            [_c("vue-qr", { attrs: { size: 200, text: _vm.signQrcode } })],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.signQrcodeDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }